import { AfterViewInit, Component, OnInit, inject } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { forkJoin } from 'rxjs';
import { ExportCoverSheet } from '../../../models/export-cover-sheets';
import { ExportCoverSheetsService } from '../../../services/export-cover-sheets/export-cover-sheets.service';
import { GungModalService } from '../../../services/gung-modal/gung-modal.service';
import { NewCoverSheetModalComponent } from '../new-cover-sheet-modal/new-cover-sheet-modal.component';
import { UpdateCoverSheetImagesModalComponent } from '../update-cover-sheet-images-modal/update-cover-sheet-images-modal.component';

@Component({
  selector: 'lib-export-cover-sheets-table',
  templateUrl: './export-cover-sheets-table.component.html',
  styleUrls: ['./export-cover-sheets-table.component.css'],
  standalone: false
})
export class ExportCoverSheetsTableComponent
  extends ListItemRendererComponent<ExportCoverSheet[]>
  implements OnInit, AfterViewInit
{
  protected gungModalService = inject(GungModalService);
  protected modalService = inject(NgbModal);
  protected exportCoverSheetsService = inject(ExportCoverSheetsService);
  protected translationService = inject(TranslateService);

  unsaved: boolean;
  loader = true;

  ngOnInit(): void {
    this.loader = false;
  }

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }

  onCreate() {
    const modalRef = this.modalService.open(NewCoverSheetModalComponent, { size: 'lg' });
    modalRef.result.then(
      result => {
        if (result) {
          this.data.push(result);
        }
      },
      () => {}
    );
  }

  edit(coverSheet: ExportCoverSheet) {
    const modalRef = this.modalService.open(NewCoverSheetModalComponent, { size: 'lg' });
    modalRef.componentInstance.edit = coverSheet;
    modalRef.result.then(
      result => {
        if (result) {
          const index = this.data.findIndex(s => s.id === result.id);
          if (index !== -1) {
            this.data[index] = result;
          } else {
            this.data.push(result);
          }
        }
      },
      () => {}
    );
  }

  showImages(index: number) {
    const element = this.data[index];
    const modalRef = this.modalService.open(UpdateCoverSheetImagesModalComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: true
    });
    modalRef.componentInstance.data = JSON.parse(JSON.stringify(element));
    modalRef.result.then(
      result => {
        if (result === null || result.image === null) {
          this.data = this.data.filter(s => s.id !== element.id);
        } else {
          this.data[index] = result;
        }
      },
      () => {}
    );
  }

  drop(event: CdkDragDrop<string[]>) {
    this.unsaved = true;
    moveItemInArray(this.data, event.previousIndex, event.currentIndex);
  }

  onSave() {
    const listHttpPut = [];
    for (const [index, sheet] of this.data.entries()) {
      listHttpPut.push(this.exportCoverSheetsService.putExportCoverSheet({ ...sheet, index }));
    }
    forkJoin(listHttpPut).subscribe(() => (this.unsaved = false));
  }

  onDelete(id: string) {
    this.gungModalService
      .openConfirmYesNoModal(undefined, this.translationService.instant('CONFIRM_DELETION', { value: '' }) + '?', {
        size: 'sm'
      })
      .then(
        result => {
          if (result) {
            this.exportCoverSheetsService
              .deleteExportCoverSheet(id)
              .subscribe(() => (this.data = this.data.filter(s => s.id !== id)));
          }
        },
        () => {}
      );
  }
}
